import {
  MissingMappingStoreModel as MissingMappingStore, MissingMappingValuesWire,
  MissingMappingWire, PostSearchResponseWire, PostSearchURLParams
} from "app/area/code-mappings/types";
import {
  CodeMappingsListItems, GroupedResult, ModifiedCodeMappings,
  ModifiedCodeMappingsModel, PostSearchFinalData
} from "app/area/code-mappings/types-store";
import { isDefinedIncludingZero } from "app/infrastructure/data/number";

export const mapMissingMappings = (missingMappingsWire: MissingMappingWire): MissingMappingStore[] => {
  const newData = missingMappingsWire.missingMappings.reduce(
    (obj, item) => Object.assign(obj,
      {
        [item.codetable.v]: {
          codetable: {
            value: item.codetable?.v,
            description: item.codetable?.d,
            ctg: item.codetable?.ctg
          }
        }
      }
    ), {});

  return Object.keys(newData).map(key => newData[key]).reduce((a, b) => a.concat(b), []) ?? [];
};

export const mapUpdatedMissingMappings = (missingMappingsWire: MissingMappingWire): MissingMappingStore[] => {
  const newData = missingMappingsWire.missingMappings.reduce(
    (obj, item) => Object.assign(obj,
      {
        [item.codetable.v]: item.externalValues.map(value => {
          return {
            id: value?.v,
            description: value?.d,
            codetable: {
              value: item.codetable?.v,
              description: item.codetable?.d,
              ctg: item.codetable?.ctg
            }
          };
        })
      }
    ), {});

  return Object.keys(newData).map(key => newData[key]).reduce((a, b) => a.concat(b), []) ?? [];
};

export const mapPostSearchParams = (missingMappingsRaw: MissingMappingWire): PostSearchURLParams => {
  return {
    importMappings: missingMappingsRaw.missingMappings.map(item => {
      return {
        codetableId: item.codetable.v,
        externalValues: item.externalValues.map(data => data.v)
      };
    })
  };
};

export const mapPostSearch = (postSearchRaw: PostSearchResponseWire): PostSearchFinalData[] => {
  const newData = postSearchRaw.results.reduce(
    (obj, item) => Object.assign(obj, { [item.codetable.v]: item.values }), {});

  return Object.keys(newData)?.map(key => {
    return newData[key]?.map(item => {
      return {
        id: item.externalValue,
        codetable: { value: parseInt(key, 10) },
        code: { value: item.code?.v, description: item.code?.d },
        codeCategory: { value: item?.code?.ctg }
      };
    });
  }).reduce((a, b) => a.concat(b), []);
};

export const mapList = (missingMappingsWire: MissingMappingWire) => {
  return {
    filename: { value: missingMappingsWire?.filename?.v, description: missingMappingsWire?.filename?.d },
    importSet: { value: missingMappingsWire?.importSet?.v, description: missingMappingsWire?.importSet?.d },
    missingMappingsExists: missingMappingsWire?.missingMappingsExists,
    results: mapMissingMappings(missingMappingsWire)
  };
};

export const mapUpdatedList = (missingMappingsWire: MissingMappingWire, postSearchModel: PostSearchFinalData[]) => {
  return {
    filename: { value: missingMappingsWire?.filename?.v, description: missingMappingsWire?.filename?.d },
    importSet: { value: missingMappingsWire?.importSet?.v, description: missingMappingsWire?.importSet?.d },
    missingMappingsExists: missingMappingsWire?.missingMappingsExists,
    results: mapUpdatedMissingMappings(missingMappingsWire).map(item => {
      const code = postSearchModel.find(elem => elem.id === item?.id && elem.codetable?.value === item.codetable?.value);
      return {
        ...item,
        code: code?.code,
        codeCategory: code?.codeCategory
      };
    })
  };
};

export const mapModifiedItems = (modifiedItems: ModifiedCodeMappings[]): ModifiedCodeMappingsModel[] => {

  const grouped = modifiedItems.reduce((hash, obj) => ({
    ...hash, [obj.codetable]: (hash[obj.codetable] || [])
      .concat(obj)
  }), {});

  const keys = Object.keys(grouped);

  return keys.map(key => {
    return {
      codetableId: parseInt(key, 10),
      mappings: grouped?.[key]?.map(data => {
        return {
          externalValue: String(data.id),
          ...(isDefinedIncludingZero(data.code.value) && {
            code: data.code.value
          })
        };
      })
    };
  });
};

export const groupCodeMappings = (values: CodeMappingsListItems[]): GroupedResult => {
  return values
    .reduce((hash, obj) => ({
      ...hash, [obj.codetable.value]: (hash[obj.codetable.value] || [])
        .concat(obj)
    }), {});
};

export const getCodetableIds = (missingMappings: MissingMappingValuesWire[]): string[] =>
  missingMappings.map(item => item.codetable.v.toString());
